import graphqlClient from '@/graphql/graphql-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  DeleteContactsDocument,
  type DeleteContactsMutationVariables,
} from '@/graphql/generated/graphql';

export const useDeleteContacts = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ['delete-contacts'],
    mutationFn: (variables: DeleteContactsMutationVariables) =>
      graphqlClient.request(DeleteContactsDocument, variables),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contacts'] });
    },
  });

  return {
    ...mutation,
    deleteContacts: mutation.mutate,
    deleteContactsAsync: mutation.mutateAsync,
  };
};

export default useDeleteContacts;
